import { User } from '@core/models/users.model';
import { createAction, props } from '@ngrx/store';

import { CoreCacheState } from './core.models';


const loadState = createAction('[Core] Load state');
const stateLoaded = createAction('[Core] State loaded', props<{ currentUser: User; accessToken: string }>());

const login = createAction('[Core] Login', props<{ username: string; password: string; returnUrl?: string }>());
const loggedIn = createAction('[Core] Logged in', props<{ user: User; accessToken: string; returnUrl?: string }>());
const logout = createAction('[Core] Logout');
const loggedOut = createAction('[Core] Logged out');

const changePassword = createAction('[Core] Change password', props<{ username: string; oldPassword: string; newPassword: string }>());

const cacheEnablings = createAction('[Core] Cache enablings');
const cacheEnablingById = createAction('[Core] Cache enabling by id', props<{ id: number }>());
const cacheExternalWs = createAction('[Core] Cache external webservices');
const cacheProcedureById = createAction('[Core] Cache procedure by id', props<{ id: number }>());
const cacheWorkGroupById = createAction('[Core] Cache workGroup by id', props<{ id: number }>());

const cached = createAction('[Core] Resource cached', props<{ key: keyof CoreCacheState; payload: any[] }>());

export const coreActions = {
  loadState,
  stateLoaded,

  login,
  loggedIn,
  logout,
  loggedOut,

  changePassword,

  cacheEnablings,
  cacheEnablingById,
  cacheExternalWs,
  cacheProcedureById,
  cacheWorkGroupById,

  cached
};
